import config from '@/config'
import Groups from '@/models/Groups'
import BaseService from './BaseService'
import { requests } from './HTTPService'

interface GetAttendeesParams {
  limit?: number
  prevId?: string
}

interface Attendee {
  id: string
  fullName: string
  avatar?: string
  email: string
  rsvpStatus: string
  rsvpDate: string
}

const http = requests(config?.COMMUNITIES_SERVER_URL)
export default class EventsRSVPService extends BaseService<Groups> {
  protected basePath = ''

  model(): typeof Groups {
    return Groups
  }

  constructor(locationId: string, groupId: string) {
    super(locationId)
    this.basePath = `/${locationId}/groups/${groupId}/rsvp`
  }

  async rsvpByEventId(eventId: string, data: any): Promise<any> {
    const response = await http.post(`${this.endpoint}/${eventId}`, data)
    return response.data
  }

  async unrsvpByEventId(eventId: string, data: any): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${eventId}/decline`,
      data
    )
    return response.data
  }

  async getEventRSVPs(eventId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/${eventId}`)
    return response.data
  }

  async getEventAttendees(
    eventId: string,
    params?: GetAttendeesParams
  ): Promise<{ attendees: Attendee[]; hasMore: boolean }> {
    const queryParams = new URLSearchParams()
    if (params?.limit) queryParams.append('limit', params.limit.toString())
    if (params?.prevId) queryParams.append('prevId', params.prevId)

    const response = await http.get(
      `${this.endpoint}/${eventId}/attendees?${queryParams.toString()}`
    )
    return response.data
  }

  async getEventRSVPCount(eventId: string): Promise<{ count: number }> {
    const response = await http.get(`${this.endpoint}/${eventId}/count`)
    return response.data
  }
}
